import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import PathPickProductCardMarketBlock from "@/features/pathpick/components/product/PathPickProductCardMarketBlock";
import {
  PathPickMarket,
  PathPickMarketPriceBasis,
  PathPickProductCardComparisonLayout,
  PathPickProduct,
} from "@/features/pathpick/types";
import {
  getPathPickMarketExternalUrl,
  PathPickMarketMetrics,
} from "@/features/pathpick/utils/market";

interface Props {
  item: PathPickProduct;
  kreamMetrics: PathPickMarketMetrics;
  poizonMetrics: PathPickMarketMetrics;
  basis: PathPickMarketPriceBasis;
  layout: PathPickProductCardComparisonLayout;
  onOpenMarginFormula: (market: PathPickMarket) => void;
}

const DIVIDER_COLOR = "#EFEFED";

/**
 * KREAM·POIZON 두 블록과 그 사이 구분선.
 *
 * `side`(나란히 보기)는 화면 폭과 무관하게 항상 좌우로 놓는다. 좁은 카드에서 열이 접히는
 * 문제는 카드 그리드의 최소 폭(side 240px)이 막는다 — 모바일은 카드가 한 줄에 1장이라 오히려
 * 넓다. 구분선은 `stack`이면 위 테두리(가로선), `side`면 왼쪽 테두리(세로선)다.
 * (flex 컨테이너의 기본 stretch 덕분에 0폭 Box가 열 방향에서는 가로선, 행 방향에서는 세로선이 된다)
 */
function PathPickProductCardComparison({
  item,
  kreamMetrics,
  poizonMetrics,
  basis,
  layout,
  onOpenMarginFormula,
}: Props) {
  const isSide = layout === "side";

  return (
    <Flex
      flexDirection={isSide ? "row" : "column"}
      gap={"8px"}
    >
      <Box
        borderTop={isSide ? "none" : `0.5px solid ${DIVIDER_COLOR}`}
        display={isSide ? "none" : "block"}
      />
      <PathPickProductCardMarketBlock
        metrics={kreamMetrics}
        basis={basis}
        layout={layout}
        externalUrl={getPathPickMarketExternalUrl(item, "KREAM")}
        onOpenMarginFormula={() => onOpenMarginFormula("KREAM")}
      />
      <Box
        borderTop={isSide ? "none" : `0.5px solid ${DIVIDER_COLOR}`}
        borderLeft={isSide ? `0.5px solid ${DIVIDER_COLOR}` : "none"}
      />
      <PathPickProductCardMarketBlock
        metrics={poizonMetrics}
        basis={basis}
        layout={layout}
        externalUrl={getPathPickMarketExternalUrl(item, "POIZON")}
        onOpenMarginFormula={() => onOpenMarginFormula("POIZON")}
      />
    </Flex>
  );
}

export default PathPickProductCardComparison;
